<template>
    <div :class="['divider-container', currentStyle]" :style="cssVars">
        <div class="divider-line"></div>
    </div>
</template>

<script>
export default {
    name: 'DividerView',
    props: {
        currentStyle: {
            type: String,
            default: () => ''
        },
        value: {
            type: Object,
            default: () => {}
        }
    },
    computed: {
        cssVars() {
            return {
                '--divider-color': this.value.color,
                '--divider-width': (this.value.lineWidth || 1) + 'px',
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.divider-container {
    width: 100%;

    .divider-line {
        margin: 4px 0;
        width: 100%;
        border-bottom: var(--divider-width) solid var(--divider-color);
    }
}
</style>
